export const months = [
  'Enero',
  'Febrero',
  'Marzo',
  'Abril',
  'Mayo',
  'Junio',
  'Julio',
  'Agosto',
  'Septiembre',
  'Octubre',
  'Noviembre',
  'Diciembre'
];

export const Days = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];

export function formatDate(fullDate: Date): string {
  const day = Days[fullDate.getDay()];
  const date = fullDate.getDate();
  const month = months[fullDate.getMonth()];
  const year = fullDate.getFullYear();
  return `${day} - ${date} ${month}, ${year}`;
}

export function formatTime(date: Date): string {
  return date.toLocaleString('en-US', {
    hour: 'numeric',
    minute: 'numeric',
    hour12: true
  });
}

export function formatSimpleDate(data: string): string {
  const fullDate = new Date(data);
  const date = fullDate.getDate();
  const month = months[fullDate.getMonth()];
  const year = fullDate.getFullYear();
  return `${date}/${month}/${year}`;
}

export function toISOString(date: Date): string {
  const isoDateTime = new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString();
  return isoDateTime;
}
